<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="EC_width content">
      <div class="timezhou">
        <div class="yearWrap">
          <span :class="{ yearActive: timelineIndex == 0 }">2030</span>
          <span :class="{ yearActive: timelineIndex == 10 }">2020</span>
          <span>2010</span>
          <span>2000</span>
        </div>
        <div class="lineWrap">
          <span class="linelv" :class="{ activelinelv: timelineIndex == 0 }"></span>
          <span class="linelv" :class="{ activelinelv: timelineIndex == 10 }"></span>
        </div>
      </div>
      <div class="positionBtn marginBottom40">
        <swiper :options="swiperOption" ref="mySwiper" class="imgBanner"
          @slideChangeTransitionEnd="slideChange($event)">
          <swiper-slide v-for="(item, index) in datalist" :key="'0' + index">
            <a href="javascript:;" :class="{ timeItem_active: yearTagindex == index }" class="timeItem "
              @click="yearClick(item, index)">
              {{ item }}
            </a>
          </swiper-slide>
        </swiper>
        <div class="prevbutton">&lt;</div>
        <div class="nextbutton">&gt;</div>
      </div>
      <div class="number">
        <table>
          <tr v-for="(item, index) in qilist2" :key="'0' + index">
            <td :class="{ activeTd: periodsTagindex == qitem }" v-for="(qitem, index2) in item" style="width:72px"
              :key="'0' + index + index2" @click="periodsTag(qitem)"><a style="width:72px"
                href="javascript:void(0);">No.{{ qitem }}</a></td>
          </tr>
        </table>
      </div>
      <div class="taggleMain">
        <div class="titleTageWrap">
          <span class="tagTitle tagTitleActive">{{ periodsTagindex }},{{ datalist[yearTagindex] }}</span>
        </div>
        <div class="listWrap">

          <a href="#" @click="newclick(item)" class="listItem" v-for="(item, index) in newArticleList" :key="index"
            v-show="item.title">
            <div class="listItemTitle">
              {{ item.title }}
            </div>
            <div class="display_between opera">
              <div v-show="item.indexContent" style="width:1030px">

                <div class="listItemSub">
                  {{ item.communicationAuthor }}
                </div>
              </div>
              <div class="inforshow">
                <span>Time: <span>{{ formatDate_new(item.publicationdate) }}</span></span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from "../home/breadcrumbPage"
import lodash from "lodash"
export default {
  name: "enLiteList3",
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 10,
        slidesPerGroup: 10,
        navigation: {
          nextEl: '.nextbutton',
          prevEl: '.prevbutton',
          disabledClass: 'my-button-disabled',
        },
      },
      timelineIndex: 0,
      // 期数
      periods: [],
      // 年份激活index
      yearTagindex: 0,
      // 期数激活index
      periodsTagindex: '',
      // 菜单激活index
      tagMenuindex: 0,
      // 页数激活index
      pageIndex: 1,
      pageAll: 8,
      apiData: {
        yearNum: {},
        periods: {},
        newslist: {}
      },
      datalist: [],
      qilist: [],
      qilist2: [],
      newArticleList: []
    }
  },
  created() {
    this.getData()
    this.GetArticleBrowseInfo()
    this.periodsTagindex = this.$route.query.qi
    this.GetArticleInfoPageList(this.$route.query.nian.toString(), Number(this.$route.query.qi).toString())
  },
  methods: {
    // 首页
    firstPage() {
      this.pageIndex = 1
    },
    // 尾页
    lastPage() {
      this.pageIndex = this.pageAll
    },
    // 页数点击
    pageSet(index) {
      this.pageIndex = index
    },
    // 上一页
    prePage() {
      if (this.pageIndex > 1) {
        this.pageIndex--
      }

    },
    // 下一页
    nextPage() {
      if (this.pageIndex < this.pageAll) {
        this.pageIndex++
      }
    },
    // 菜单切换
    tagMenu(index) {
      this.tagMenuindex = index;
      // 根据index0、1更新列表数据
      this.apiData.newslist.data = []
    },
    // 期数切换
    periodsTag(qitem) {
      this.periodsTagindex = qitem
      // 根据item更新列表数据
      this.GetArticleInfoPageList(this.datalist[this.yearTagindex], Number(this.periodsTagindex).toString())
    },
    getData() {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        var usedata = data.enLiteList2.periods;
        that.periods = lodash.chunk(usedata, 18);
        that.apiData = data.enLiteList2
      })
    },
    slideChange() {
      this.timelineIndex = this.swiper.activeIndex
    },
    // 年份点击
    yearClick(year, index) {
      this.yearTagindex = index;
      this.qilist = [];
      this.qilist2 = [];
      this.datalist = []
      // 根据年份year获取数据
      this.GetArticleBrowseInfo()
      this.GetArticleInfoPageList(year, Number(this.periodsTagindex).toString())

    },
    GetArticleBrowseInfo() {
      let _this = this;
      _this.httphelper.get('/api/FmchApi/GetFmchInfoPageList').then(res => {
        if (res.code == 200) {
          _this.getdatalist(res.data.articleSelectTree);
        }
      });
    },
    getdatalist(data) {
      this.datalist = []
      for (var i = 0; i < data.length; i++) {
        this.datalist.push(data[i].label)
        if (i == this.yearTagindex) {
          this.qilist = []
          for (var j = 0; j < data[i].children.length; j++) {
            this.qilist.push(data[i].children[j].label)
          }
        }
      }
      this.qilist2 = lodash.chunk(this.qilist, 18)
    },
    GetArticleInfoPageList(year, period) {
      this.newArticleList = ''
      let _this = this;
      _this.httphelper.post('/api/FmchApi/GetFmchArticleInfoPageList', {
        year: year,
        period: period,
        id: 0,
        keywords: ''
      })
        .then(res => {
          if (res.data.code == 200) {
            _this.newArticleList = res.data.data.gpSiteFmchArticleInfoViews || null;
          }
        });
    },
    newclick(e) {
      this.$router.push({ name: 'enLiteDetail3', query: { title: e.title, nian: e.year, qi: e.period, id: e.id } });
    },
    delHtmlTag(str) {
      return str.replace(/<[^>]+>/g, "");  //正则去掉所有的html标记
    },
    formatDate_new(date) {
      // 确保 date 存在且是有效的 Date 对象
      if (!date) return 'N/A'; // 如果 date 是 null 或 undefined，返回默认值
      const parsedDate = date instanceof Date ? date : new Date(date);
      // 检查解析后的日期是否有效
      if (isNaN(parsedDate.getTime())) return 'Invalid Date'; // 处理无效日期
      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const day = String(parsedDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
  components: {
    breadcrumbPage
  }
}
</script>

<style scoped>
.content {
  padding-top: 20px;
  flex: 1;
  padding-bottom: 60px;
}

.searchTitle {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #ddd;
}

.searchTitleText {
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #333;
}

.searchInput {
  position: relative;
}

.searchInput img {
  position: absolute;
  left: 10px;
  top: 23px;
}

.searchInput input {
  height: 30px;
  border: none;
  background: #ebebeb;
  width: 226px;
  outline: none;
  border-radius: 5px;
  padding-left: 30px;
  box-sizing: border-box;
}

.page_btn {
  color: #999;
  cursor: pointer;
  display: inline-block;
  width: 28px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 30px;
  border: 1px solid #ccc;
}

.page_btn_active {
  background: #0b8686;
  color: #fff;
  border: 1px solid #0b8686;
}

.timeItem {
  width: 88px;
  height: 34px;
  font-size: 18px;
  text-align: center;
  line-height: 34px;
  font-weight: bold;
  display: inline-block;
  color: #333;
  border-radius: 7px 0px 7px 0px;
}

.timeItem_active {
  background: linear-gradient(90deg, #3a9a9b, #007476);

  color: #fff;
}

.number {
  margin-top: 20px;
}

.number table {
  border-collapse: collapse;
  /* 	border: 1px solid #ddd; */
}

.number table td {
  border: 1px solid #dee2e6;
  height: 30px;
  text-align: center;
  cursor: pointer;
}

.number table td a {
  width: 100%;
  height: 100%;
  line-height: 30px;
  display: inline-block;
}

.activeTd a {
  background-color: #0b8686;
  color: #fff;
}

/* 列表切换部分 */
/* 气泡框 */

.rectangle {
  position: relative;
  padding: 10px 0;
  width: 124px;
  text-align: center;
  cursor: pointer;
  color: #0b8686;
  display: inline-block;
  font-weight: bold;
}

.rectangleActive {
  background: #0b8686;
  color: #fff;
}

.rectangle~.rectangle::before {
  content: '|';
  position: absolute;
  left: -3px;
  color: #ddd;
}

.rectangle .trangle {
  position: absolute;
  top: 38px;
  right: 45%;
  width: 0;
  height: 0;
  font-size: 0;
  border: solid 8px;
  border-color: #0b8686 transparent transparent transparent;
  display: none;
}

.rectangleActive .trangle {
  display: inline-block;
}

.taggleMain {
  padding-top: 40px;
}

.titleTageWrapSpe {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 40px;
}

.titleTageWrap {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 40px;
}

.tagTitle {
  display: inline-block;
  height: 100%;
  font-size: 18px;
  cursor: pointer;
  font-weight: bold;
  position: relative;
  margin-right: 20px;
}

.tagTitle~.tagTitle::before {
  content: '|';
  margin: 0 14px;
  color: #ddd;
  position: absolute;
  left: -28px;
}

.tagTitleActive {
  border-bottom: 1px solid #0b8686;
  color: #0b8686;
}

/* 列表 */
.listItem {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
  display: block;
}

.listItem:last-child {
  border-bottom: none;
}

.listItemTitle {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  position: relative;
}

.listItemSub {
  font-size: 16px;
  color: #ccc;
}

.opera {
  margin-top: 10px;
}

.gree_block,
.red_block,
.blue_block {
  display: inline-block;
  padding: 0 8px;
  font-size: 12px;
  margin-right: 5px;
  height: 20px;
  line-height: 20px;
  border-radius: 2px;
}

.gree_block {
  border: 1px solid #469a97;
  color: #469a97;
}

.red_block {
  border: 1px solid #cc6d6e;
  color: #cc6d6e;
}

.blue_block {
  border: 1px solid #417393;
  color: #417393;
}

.inforshow {
  color: #ccc;
}

.positionBtn {
  margin-top: 20px;
  position: relative;
  width: 1240px;
}

.nextbutton,
.prevbutton {
  display: inline-block;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  box-sizing: border-box;
  border-radius: 30px;
  background: #0b8586;
  color: #fff;
  position: absolute;
  top: 9%;
  z-index: 10;
  cursor: pointer;
  outline: none;
}

.nextbutton {
  right: -30px;
  left: auto;
}

.prevbutton {
  right: auto;
  left: -30px;
}

.swiper-slide {
  text-align: center;
}

.my-button-disabled {
  background: #ddd;
  color: #999;
}

.timezhou {
  height: 1px;
  background: #bfbfbf;
  padding-left: 100px;
  margin: 30px 0;
  margin-top: 70px;
  line-height: 0;
  position: relative;
}

.yearWrap {
  font-size: 22px;
  position: absolute;
  top: -30px;
  left: 73px;
}

.yearWrap span {
  margin-right: 71px;
}

.yearActive {
  color: #0b8586;
}

.lineWrap {
  /*position: relative;*/
  float: left;
  margin-top: -3px;
}

.linelv {
  /*position: absolute;*/
  width: 122px;
  display: inline-block;
  height: 3px;
  /*background: #0B8586;*/
  position: relative;
}

.activelinelv {
  background: #0b8586;
}

.linelv:before {
  content: url(/image/icon/timelinenormal.png);
  position: absolute;
  top: -8px;
  left: -10px;
}

.linelv:after {
  content: url(/image/icon/timelinenormal.png);
  position: absolute;
  top: -8px;
  right: -10px;
}

.activelinelv:before {
  content: url(/image/icon/timelineactive.png);
  position: absolute;
  top: -8px;
  left: -10px;
  z-index: 10;
}

.activelinelv:after {
  content: url(/image/icon/timelineactive.png);
  position: absolute;
  top: -8px;
  right: -10px;
  z-index: 10;
}
</style>
